/**
 * @generated SignedSource<<3fcb4c22900e6c57db11f586f14bc81a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "ResetResponse",
    "kind": "LinkedField",
    "name": "register",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "signUpComponentsRegisterMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "signUpComponentsRegisterMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5a61f60283c6078294e95c0cc539d937",
    "id": null,
    "metadata": {},
    "name": "signUpComponentsRegisterMutation",
    "operationKind": "mutation",
    "text": "mutation signUpComponentsRegisterMutation(\n  $request: RegisterRequestInput\n) {\n  register(request: $request) {\n    username\n  }\n}\n"
  }
};
})();

node.hash = "b42b37d1c4a35e3805d0ada1d44ed748";

module.exports = node;
